import styles from './Header.module.css';

interface HeaderProps {
    path: string;
    logout(): void;
    search(): void;
}

export function Header({ path, logout, search }: HeaderProps) {
    const isLoginPage = path === 'login';
    const items = isLoginPage
        ? []
        : [
              {
                  text: 'Search Individuals',
                  click: search,
                  disabled: path === 'individuals',
              },
              {
                  text: 'Logout',
                  click: logout,
                  disabled: path === '',
              },
          ];

    const navBarItems = items.map((item) => (
        <li key={'navbar-' + item.text} className={styles.navItem}>
            <button
                disabled={item.disabled}
                className={styles.navButton}
                onClick={item.click}
            >
                {item.text}
            </button>
        </li>
    ));

    return (
        <ul className={styles.navbar}>
            <li className={styles.brand}>
                <img
                    src={process.env.PUBLIC_URL + '/favicon.svg'}
                    alt=""
                    className={styles.brandIcon}
                />
                Family Tree
            </li>
            {navBarItems}
        </ul>
    );
}
